import { Money } from '@reg/shared/model/money.model';

/**
 * Model to hold a plan subscription used to purchase a plan through Stripe
 */
export class PlanSubscription {
    public monthly: boolean;
    public yearly: boolean;
    public costPerMonth: Money = {} as Money;
    public id: number;
    public period: string;
    public name: string = 'Basic';
    public price: Money = {} as Money;
    public showPlan: boolean;
    public percentageSaved: number | undefined;

    /**
     * Deserialize to a json api format
     */
    public deserialize(json: any): PlanSubscription {
        const data: Object = json['data'] || json;

        this.id = data['id'];
        this.name = data['name'];
        this.yearly = data['yearly'];
        this.monthly = data['monthly'];
        this.costPerMonth = data['cost_per_month'];
        this.period = data['period'];
        this.price = data['price'];
        this.showPlan = data['show_plan'];
        this.percentageSaved = data['percentage_saved'];

        return this;
    }
}
